module.exports = __webpack_public_path__ + "img/nespresso_limited_vertuo_next_black.990b5d4.jpg";